<template>
  <div class="appointment-table">
    <div class="row-header">
      <div class="cell">บริการ</div>
      <div class="cell">ชื่อแพ็กเกจ</div>
      <div class="cell">ผู้นัดหมาย</div>
      <div class="cell">วันนัดหมาย</div>
      <div class="cell">นัดเมื่อ</div>
      <div class="cell"></div>
    </div>
    <appointment-list-item
      v-for="item in data"
      :key="item.id"
      v-bind="item"
    ></appointment-list-item>
  </div>
</template>

<script>
import AppointmentListItem from "./AppointmentListItem";

export default {
  components: {
    AppointmentListItem
  },
  props: ["data"]
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.appointment-table > .row-header {
  display: grid;
  grid-template-columns: 2fr 2fr 1.5fr 1fr 1fr 1fr;
  grid-gap: 10px;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 3) $space;

  > .cell {
    font-size: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/appointments/components/AppointmentTable.vue